import { useTranslation } from 'react-i18next';

const topics = [
  { key: 'review', icon: 'ri-star-line', color: 'text-accent-600 bg-accent-50', href: '/cssbuy-review/' },
  { key: 'shipping', icon: 'ri-truck-line', color: 'text-primary-600 bg-primary-50', href: '/shipping/' },
  { key: 'coupon', icon: 'ri-coupon-line', color: 'text-accent-600 bg-accent-50', href: '/article/cssbuy-coupon/' },
  { key: 'discount', icon: 'ri-price-tag-3-line', color: 'text-primary-600 bg-primary-50', href: '/article/cssbuy-discount-code/' },
  { key: 'warehouse', icon: 'ri-building-4-line', color: 'text-secondary-700 bg-secondary-100', href: '/article/cssbuy-warehouse/' },
  { key: 'legit', icon: 'ri-shield-check-line', color: 'text-primary-600 bg-primary-50', href: '/article/cssbuy-legit/' },
];

export default function TopicsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
              {t('topics_title')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {topics.map((topic) => (
              <a
                key={topic.key}
                href={topic.href}
                className="group block bg-white rounded-xl p-6 border border-background-200 hover:border-primary-300 hover:shadow-md transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className={`w-12 h-12 rounded-lg ${topic.color} flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform`}>
                    <i className={`${topic.icon} w-6 h-6 flex items-center justify-center text-xl`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-sm text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                      {t(`topic_${topic.key}_title`)}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                      {t(`topic_${topic.key}_desc`)}
                    </p>
                  </div>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors mt-1" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}